import { render, staticRenderFns } from "./CreateQuestionModal.vue?vue&type=template&id=19f38f74&scoped=true&"
import script from "./CreateQuestionModal.vue?vue&type=script&lang=js&"
export * from "./CreateQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestionModal.vue?vue&type=style&index=0&id=19f38f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f38f74",
  null
  
)

export default component.exports